/* eslint-disable class-methods-use-this */
/* eslint-disable camelcase */

/*
 * IMPORT POLYFILLS
 *
 * we need to check in the end what we need
 *
 */

/*
import 'core-js/features/object/assign';
import 'core-js/features/object/keys';
import 'core-js/features/array/includes';
import 'core-js/features/dom-collections/for-each';
import 'classlist-polyfill';
*/


import 'core-js/features/promise';
import 'whatwg-fetch';
import 'intersection-observer';
import 'svg-innerhtml-polyfill';
import 'classlist-polyfill';

/*
 * IMPORT STYLES
 */

import './scss/main.scss';

/*
 * LOCAL IMPORTS
 */

import { Logger, setLogLevel } from './logger';
import touchDetect from './touch-detect';
import iframeDetect from './iframe-detect';
import featureDetect from './feature-detect';
import {
  // loadStyle,
  // loadScript,
  getParameters,
  getNode,
  // loadMapbox,
} from './utils';
import {
  setLanguage,
  activateTranslationCollection,
  getTranslationCollection,
  setTranslationsPath,
  loadTranslations,
// t,
} from './language';
import { setFontTheme } from './fonts';
import { setColorTheme } from './colors';
import Chart from './chart';

/*
 * IMPORT STUFF THAT SHOULD END UP IN THE MAIN CHUNK
 */
// import './switch';
// import './slider';
// import './sliderplay';
// import './linechart';
// import './barcharth';
// import './barchart';
// import './map';

/*
 * IMPORT INDIVIDUALS CHARTS
 */

/*
import population_metroareas from './charts/population_metroareas';
import rent_overburden_urbanisation from './charts/rent_overburden_urbanisation';
import share_tenants from './charts/share_tenants';

const chartFunctions = {
  population_metroareas,
  rent_overburden_urbanisation,
  share_tenants,
};
*/


// loadMapbox();

/*
 * MAIN CLASS
 *
 * to be used as a singleton
 */

class TsgGraphics {
  constructor(params) {
    this.log = new Logger('tsg_main');
    this.log.debug('started');

    this.touchDetect = touchDetect;
    this.iframeDetect = iframeDetect;
    this.setLogLevel = setLogLevel;
    this.getTranslationCollection = getTranslationCollection;
    this.activateTranslationCollection = activateTranslationCollection;
    this.setTranslationsPath = setTranslationsPath;

    this.params = params || {};
    if (iframeDetect.inFrame) this.processParameters();
    this.paramsToGlobals();
    this.setLanguage();

    if (iframeDetect.inFrame) {
      this.setFontTheme();
      this.setColorTheme();
      if (window.TSG_CHART) {
        window.addEventListener('load', () => {
          this.makeChart(document.querySelector('#tsg-graphic'), window.TSG_CHART);
        });
      }
    }
  }

  setOptions(params) {
    this.params = { ...this.params, ...params };
    this.paramsToGlobals();
    this.setLanguage();
    this.setFontTheme();
    this.setColorTheme(this.params.colortheme, this.params.colors || {});
  }

  // convert url parameters in iframes to globals vars, so we
  // only have to handle one case
  // UPDATE: not sure whether this is a good idea... in the end it would be
  // good to store this stuff here...
  processParameters() {
    const ps = getParameters();
    /*
    Object.keys(ps).forEach((k) => {
      ps[k] = decodeURIComponent(ps[k]);
    });
    */
    this.params = { ...this.params, ...ps }; // ...which I do for now
  }

  paramsToGlobals() {
    Object.keys(this.params).forEach((k) => {
      window[`TSG_${k.toUpperCase()}`] = this.params[k];
    });
  }

  setLanguage(l) {
    setLanguage(l || this.params.lang || 'en', this.params.user);
  }

  setFontTheme(t, noAssets) {
    setFontTheme(t || this.params.fonttheme || 'roboto', noAssets || this.params.nofontassets);
  }

  setColorTheme(t, cs = {}) {
    const colors = {
      primary: this.params.c1,
      secondary: this.params.c2,
      bg: this.params.cbg,
      ...cs,
    };
    setColorTheme(t || this.params.colortheme || 'default1', colors);
  }

  makeChart(containerOrSelector, which, opts = {}) {
    return Promise.all([
      iframeDetect.checkFixedHeight(),
      loadTranslations(),
    ]).then((res) => {
      const fh = res[0];
      const container = getNode(containerOrSelector);

      const chart = new Chart(container, {
        heading: opts.heading || this.params.heading || '',
        text: opts.text || this.params.text || '',
        fineprint: opts.fineprint || this.params.fineprint || '',
        attribution: opts.attribution || this.params.attribution || '',
        fixedHeight: fh,
        editMode: opts.editMode,
        editCallback: opts.editCallback,
        hideattribution: opts.hideattribution || this.params.hideattribution || false,
        headingMaxWidth: opts.headingMaxWidth || this.params.headingMaxWidth,
      });

      this.log.debug(`making chart: ${which}`);
      // const p = chartFunctions[which](chart.contentElement, opts);
      //
      let options = opts.options || this.params.options || '{}';
      options = JSON.parse(options);
      options.headingMaxWidth = opts.headingMaxWidth || this.params.headingMaxWidth;
      options = JSON.stringify(options);

      const version = opts.version || this.params.version;

      return import(/* webpackChunkName:"[request]",webpackExclude:/\/quiz\// */`./charts/${which}`).then(({ default: f }) => f(chart.elems.content, options, version));
    });
  }
}


/*
 * MAIN CODE
 */


if (!window.tsgGraphics) {
  touchDetect.start(document.documentElement);
  iframeDetect.start(document.documentElement);
  featureDetect.start(document.documentElement);
  setLogLevel('ERROR');

  const tsgGraphics = new TsgGraphics();
  window.tsgGraphics = tsgGraphics;

  window.dispatchEvent(new CustomEvent('tsg-load'));
}
